import { ReactNode } from 'react';

interface SectionProps {
  children?: ReactNode;
  className?: string;
}

const Section = ({ children, className = '' }: SectionProps) => {
  return (
    <section
      className={`bg-white border border-neutral-200 mb-4 py-4 rounded-md ${className}`}
    >
      {children}
    </section>
  );
};

export default Section;
